import { Loading, RecordContextProvider, ResourceContextProvider, useGetOne } from 'react-admin';
import { useParams } from 'react-router-dom';
import { match } from 'ts-pattern';

import { CollectiveOperationsOneResponse } from '@Common/types/bo_external/collective_operations';

import { CampaignsShow } from '@Resources/campaigns/CampaignsShow';
import { SavingsFundRequestShow } from '@Resources/savings_funds_requests/SavingsFundRequestsShow';

export const CollectiveOperationsShow = () => {
  const { id } = useParams<{ id: string }>();

  const { data: collectiveOperation, isLoading: isLoadingOperation } = useGetOne(
    'collective_operations',
    { id: id ?? -1 },
    {
      enabled: !!id,
    },
  );

  const resourceName = match(collectiveOperation?.operation_type)
    .with('campaign', () => 'campaigns' as const)
    .with('matching_contribution', 'ccb_withdrawal', () => 'savings_funds_requests' as const)
    .otherwise(() => null);

  const { data: resourceData, isLoading: isLoadingResource } =
    useGetOne<CollectiveOperationsOneResponse>(
      resourceName ?? '',
      { id: collectiveOperation?.numeric_id ?? -1 },
      {
        enabled: !!resourceName && !!collectiveOperation?.numeric_id,
      },
    );

  if (isLoadingOperation || isLoadingResource || !id || !collectiveOperation || !resourceData) {
    return <Loading />;
  }

  if (!resourceName) {
    return <div>Unknown operation type</div>;
  }

  const ShowComponent = match(resourceName)
    .with('campaigns', () => CampaignsShow)
    .with('savings_funds_requests', () => SavingsFundRequestShow)
    .exhaustive();

  return (
    <ResourceContextProvider value={resourceName}>
      <RecordContextProvider value={resourceData}>
        <ShowComponent id={collectiveOperation.numeric_id} />
      </RecordContextProvider>
    </ResourceContextProvider>
  );
};
